import React from 'react';

/**
 * PatreonIcon — lucide-react doesn't include a Patreon mark, so we render
 * a small, recognizable Patreon glyph inline. Sized to match lucide icons.
 */
const PatreonIcon = ({ size = 16, strokeWidth, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {/* Solid circle (the "orbit") + vertical bar (the "column") */}
    <circle cx="15" cy="9" r="6" />
    <rect x="3" y="3" width="3" height="18" rx="0.5" />
  </svg>
);

export default PatreonIcon;
